export default "__VITE_ASSET__BvK3WI3X__"